import _ from "lodash";
import PrintIcon from "@mui/icons-material/Print";
import { IconButton } from "@mui/material";
import useNotification from "notification"

export default function ReportButton({ report, ...props }) {
    const { showError } = useNotification()

    async function generateReport() {
        if (report) {
            if (_.isFunction(report)) {
                try {
                    await report().generate()
                } catch (exceptionVar) {
                    console.error("Report generation failed (L17)", {
                        message: exceptionVar?.message,
                        name: exceptionVar?.name,
                        stack: exceptionVar?.stack,
                    })
                    showError("Ocorreu um erro ReportButton L17: " + (exceptionVar?.message || exceptionVar))
                }
            } else {
                try {
                    await report.generate()
                } catch (exceptionVar) {
                    showError("Ocorreu um erro ReportButton L24: " + exceptionVar)
                }
            }
        }
    }

    return (
        <IconButton title="Imprimir relatório" onClick={generateReport} {...props}>
            <PrintIcon />
        </IconButton>
    );
}
